import { render } from "./PostFacesSidebar.vue?vue&type=template&id=9857fcca&scoped=true&ts=true"
import script from "./PostFacesSidebar.vue?vue&type=script&lang=ts"
export * from "./PostFacesSidebar.vue?vue&type=script&lang=ts"

import "./PostFacesSidebar.vue?vue&type=style&index=0&id=9857fcca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9857fcca"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
